import { motion } from "framer-motion";
import { Medal } from "@phosphor-icons/react";

// Scores shared by the owner from the Booking.com Extranet (Nov 2026).
// booking.com blocks automated lookups — update SCORE/REVIEW_COUNT/CATEGORIES
// whenever the owner shares fresh numbers, then re-run i18n + build.
const SCORE = "9.6";
const REVIEW_COUNT = "55";
const CATEGORIES = [
  ["Cleanliness", 9.8],
  ["Facilities", 9.8],
  ["Comfort", 9.7],
  ["Value for money", 9.7],
  ["Staff", 9.7],
  ["Location", 9.5],
  ["Bed", 9.6],
  ["WiFi", 10],
];

export const BookingScores = ({ className = "" }) => (
  <motion.div
    data-testid="booking-scores"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
    className={`rounded-2xl bg-emerald text-sand p-8 md:p-12 grid lg:grid-cols-[1fr_1.3fr] gap-10 lg:gap-14 items-center ${className}`}
  >
    <div>
      <p className="overline text-gold mb-5">Rated by our Booking.com guests</p>
      <p className="flex items-end gap-3">
        <span data-testid="booking-scores-value" className="font-display text-7xl md:text-8xl leading-none text-gold">{SCORE}</span>
        <span className="text-sand/60 pb-2">out of 10</span>
      </p>
      <p className="text-sand/80 font-light mt-4">{REVIEW_COUNT} verified guest reviews</p>
      <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-gold/40 px-4 py-1.5 text-xs font-medium text-gold tracking-wide">
        <Medal size={15} weight="fill" /> Traveller Review Award
      </p>
      <p className="text-sand/50 text-xs mt-6">Verified scores from Booking.com guest reviews</p>
    </div>
    <div className="grid sm:grid-cols-2 gap-x-10 gap-y-5" data-testid="booking-scores-categories">
      {CATEGORIES.map(([label, score]) => (
        <div key={label} data-testid={`booking-score-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
          <div className="flex items-baseline justify-between mb-1.5">
            <span className="text-sm text-sand/85">{label}</span>
            <span className="text-sm font-semibold text-gold">{score}</span>
          </div>
          <div className="h-1.5 rounded-full bg-sand/15 overflow-hidden">
            <motion.div
              initial={{ width: 0 }}
              whileInView={{ width: `${score * 10}%` }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="h-full rounded-full bg-gold"
            />
          </div>
        </div>
      ))}
    </div>
  </motion.div>
);

export default BookingScores;
